import View from "core/view";
export default function TestView(element) {
  const view = View({
    element
  });
  const button = view.querySelector("button");
  function getTestElements() {
    return Array.from(view.querySelectorAll("li")).map(createTestElement);
  }
  function promisedButtonClick() {
    return new Promise((res, rej) => {
      button.addEventListener("click", click);
      function click() {
        button.removeEventListener("click", click);
        res();
      }
    });
  }
  function setButtonEnabled(enabled) {
    return button.disabled = !enabled;
  }
  function setButtonText(text) {
    button.innerHTML = text;
  }
  return Object.assign(view, {
    getTestElements,
    setButtonEnabled,
    setButtonText,
    promisedButtonClick
  });
}
function createTestElement(element) {
  const name = element.id.substring(5);
  const titleElement = element.querySelector(".title");
  const stateIconElement = element.querySelector(".state_icon");
  const stateTextElement = element.querySelector(".state_text");
  let currentState = null;
  function setTitle(title) {
    titleElement.innerHTML = title;
  }
  function setStateText(text) {
    stateTextElement.innerHTML = text;
  }
  function setStateIcon(state) {
    if (currentState && currentState != state) stateIconElement.classList.remove(currentState);
    currentState = state;
    if (currentState) stateIconElement.classList.add(currentState);
  }
  return {
    name,
    setTitle,
    setStateIcon,
    setStateText
  };
}